import { Moment } from "moment";
import Utils from "../../core/shared/utils";
import { SyncModel, SyncDataModel, DataModel } from "../../core/shared/models/syncModel";

// Requests
export class SOTRecommendationRulesSyncModel extends SyncModel {
  public hyp_cus_nr: number;
}

// Responses
export class SOTRecommendationRulesDataModel extends DataModel {
  public get DM_Key(): number | string { return this.id; }
  public id: number;
  public label: string;
  public active: boolean;
  public use_in_house_service: boolean;
  public use_pickup_service: boolean;
  public needed_article_group_ids: number[];
  public missing_article_group_ids: number[];
  public product_ids: number[];
  public deleted: boolean;
  public change_at_ymd: number;
  public change_at_hms: number;
  public get change_at(): Moment {
    return Utils.GetMomentFromInt(this.change_at_ymd, this.change_at_hms);
  }
}

export class SOTRecommendationRulesSyncDataModel extends SyncDataModel {
  public rules: SOTRecommendationRulesDataModel[];
  public get models(): DataModel[] { return this.rules; }
  public DeserializeType(): void {
    this._DeserializeType(SOTRecommendationRulesDataModel);
  }
}
